import {
  StyledContent,
  StyledHero,
  StyledLinesWrapper,
  StyledMapWrapper,
} from './Hero.styled';
import Image from 'next/image';
import Navbar from '@components/Navbar/Navbar';
import Container from '@components/Container/Container';
import Typography from '@mui/material/Typography';
import Newsletter from './Newsletter';
import Box from '@mui/material/Box';
import { Stack, Theme, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';

const Hero = () => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md')
  );

  const prepareFormat = (time: number) => {
    if (time < 10) return '0' + time;
    else return time.toString();
  };

  const countDownDate = new Date(Date.UTC(2022, 8, 16, 16)).getTime();

  const [days, setDays] = useState(0);
  const [hours, setHours] = useState('0');
  const [minutes, setMinutes] = useState('0');

  const countingDown = () => {
    const now = new Date().getTime();
    const timeleft = countDownDate - now;

    setDays(Math.floor(timeleft / (1000 * 60 * 60 * 24)));
    setHours(
      prepareFormat(
        Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      )
    );
    setMinutes(
      prepareFormat(Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60)))
    );
  };

  useEffect(() => {
    countingDown();
    setInterval(countingDown, 10000);
  }, []);

  return (
    <StyledHero>
      <StyledLinesWrapper>
        {/* <Image
          src="/images/bg-lines.svg"
          alt="Lines"
          width={1920}
          height={561}
        /> */}
      </StyledLinesWrapper>
      <StyledMapWrapper />
      {/* <Navbar /> */}
      <Container
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <StyledContent>
          <Box
            display={{ xs: 'none', md: 'flex' }}
            alignItems="center"
            justifyContent="center"
            mt={2}
          >
            {/* <Image
              src="/images/logo.svg"
              alt="Logo"
              width={isMobile ? 228 : 342}
              height={isMobile ? 52 : 78}
            /> */}
          </Box>
          {/* <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            mt={8}
          >
            <Typography variant="h1" color="text.primary" textAlign="center">
              Yor personal NUTs community
            </Typography>
            <Typography variant="h1" color="text.primary" textAlign="center">
              Climd the WALL
            </Typography>
          </Stack> */}
          <Typography
            variant="h2"
            color="text.primary"
            mt={8}
            textAlign="center"
          >
            Yor personal crypto trading companion
          </Typography>
          <Typography
            variant="h1"
            color="primary"
            mb={{ xs: 8, md: 3 }}
            textAlign="center"
          >
            Climb the WALL
          </Typography>
          <Newsletter />
        </StyledContent>
      </Container>
    </StyledHero>
  );
};

export default Hero;
